import { SessionV2 } from "@/types/auth"

// Use discriminated unions for better type safety
type AuthEvent =
  | { type: "auth-signin" }
  | { type: "auth-register" }
  | { type: "auth-signout"; signout_type: "user" | "system" }
  | { type: "auth-create-anon" }
  | { type: "auth-refresh"; session: SessionV2 }
  | { type: "session-check"; session_id: string }

type AuthEventCallback = (event: AuthEvent) => void

let channel: BroadcastChannel | null = null
const listeners: Set<AuthEventCallback> = new Set()

function getChannel(): BroadcastChannel | null {
  if (
    typeof window === "undefined" ||
    typeof BroadcastChannel === "undefined"
  ) {
    return null
  }

  if (!channel) {
    try {
      channel = new BroadcastChannel("mindtrip-auth")
      channel.onmessage = (e: MessageEvent<AuthEvent>) => {
        listeners.forEach((callback) => callback(e.data))
      }
    } catch (error) {
      console.warn("[AuthBroadcast] Failed to create channel:", error)
      return null
    }
  }

  return channel
}

export function broadcastAuthEvent(event: AuthEvent): void {
  const ch = getChannel()
  if (!ch) return
  ch.postMessage(event)
}

export function subscribeToAuthEvents(callback: AuthEventCallback): () => void {
  getChannel() // Initialize channel if needed
  listeners.add(callback)
  return () => listeners.delete(callback)
}
